<template>
  <div>
    <!-- Modal -->
    <div
      class="modal"
      :id="'resetPasswordModal' + id"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="resetPasswordModal-title"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="preview modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            
            <h4 id="resetPasswordModal-title" class="modal-title">
              Reset Password
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12" style="text-align:center">
                <div>
                  Here are your options for resetting the following password.
                </div>

                <div style="padding-top:15px;padding-bottom:15px">
                  <b v-if="passwordReset.user != null">{{
                    passwordReset.user.displayName
                  }}</b>
                  <br />
                  <b v-if="passwordReset.user != null">{{
                    passwordReset.user.email
                      ? "(" + passwordReset.user.email + ")"
                      : ""
                  }}</b>
                </div>
              </div>
            </div>
            <div class="row" v-if="passwordReset.status != 'processing'">
              <div
                v-if="passwordReset.status == 'success'"
                class="alert alert-success"
                role="alert"
                style="margin-bottom:10px"
              >
                <i class="fa fa-check marginRight8" aria-hidden="true"></i>You have successfully
                performed password reset!
              </div>
              <div
                v-if="passwordReset.status == 'fail'"
                class="alert alert-danger"
                role="alert"
                style="margin-bottom:10px"
              >
                <i class="fa fa-cross marginRight8" aria-hidden="true"></i>Error in your password reset,
                please try again!
              </div>
              <div class="col-xs-12" style="padding-bottom:15px">
                <button
                  v-if="passwordReset.user.email"
                  id="modal-reset-pwd-token-btn"
                  class="btn btn-success mainBtn"
                  style="width:100%"
                  @click.prevent="resetPassword('token')"
                  aria-label="Send Password Reset
                  Instructions via Email"
                >
                  <i class="fa fa-paper-plane marginRight8" aria-hidden="true"></i>Send Password Reset
                  Instructions via Email
                </button>
              </div>
              <div class="col-xs-12">
                <button
                  id="modal-reset-temporary-pwd-btn"
                  class="btn btn-default mainBtn"
                  style="width:100%"
                  @click.prevent="resetPassword('pin')"
                  :aria-label="'Set Temporary Password to ' + passwordReset.pin"
                >
                  Set Temporary Password to {{ passwordReset.pin }}
                </button>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-xs-12" style="text-align:center">
                Resetting..
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options"],
  created() {
    this.id = _.get(this.options, "id", "");
  },
  mounted() {
    var that = this;
    Events.listen("open-reset-password-modal" + this.id, function(data) {
      that.openResetPasswordModal(data);
    });
  },
  data() {
    return {
      id: "",
      passwordReset: {
        user: {},
        status: "none",
        pin: "",
        type: "",
        organisation: "",
      },
    };
  },
  methods: {
    //email/pin type
    resetPassword(type = "token") {
      this.passwordReset.status = "processing";
      this.passwordReset.type = type;
      var that = this;
      if (type == "token") {
        axios
          .post("password/send-token", { email: this.passwordReset.user.email })
          .then(function(response) {
            that.passwordReset.status = "success";
          })
          .catch(function(errors) {
            that.passwordReset.status = "fail";
          });
      }
      if (type == "pin") {
        axios
          .post(
            "users/" +
              this.passwordReset.user.uuid +
              "/send-temporary-password",
            { temporaryPassword: this.passwordReset.pin }
          )
          .then(function(response) {
            that.passwordReset.status = "success";
          })
          .catch(function(errors) {
            that.passwordReset.status = "fail";
          });
      }
    },
    openResetPasswordModal(data) {
      this.passwordReset.user = data.user;
      this.passwordReset.status = "none";
      /*if(this.passwordReset.user.email==null){
            	 this.passwordReset.pin = this.passwordReset.user.identity;
            	//generic
            }else{
            	this.passwordReset.pin = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
            }*/
      this.passwordReset.pin = Math.floor(
        100000 + Math.random() * 900000
      ).toString();
      $("#resetPasswordModal" + this.id).modal("show");
    },
  },
};
</script>
